import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import ApiService from "../../services/apiService";
import { method } from "lodash";
import DateTimePicker from "react-datepicker";
import Table from "../table/Table";
import { toast } from "react-toastify";
import { usePagination } from "../../hooks/usePagination";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import { format } from "date-fns";
import { color } from "highcharts";
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";
import ExportExcel from "../reports/ExportExcel";
const PumpingStationRunHours = () => {
  const now = new Date();
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  
  const [fromDateTime, setFromDateTime] = useState<any>(firstDayOfMonth);
  const [toDateTime, setToDateTime] = useState<any>(now);

 
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [selectedStationName, setSelectedStationName] = useState<any>(null);
  const [pumpingStationData, setpumpingStationData] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEnabled, setIsEnabled] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const getPumpingStation = async () => {
        try {
            const response = await ApiService.axiosApi(`/pumpingstation`, {
                method: "GET",
                params: { pageNumber: 0, pageSize: 0 },
            });
            if (response.success && response.data.data.length > 0) {
                setpumpingStationData(response.data.data);
                setSelectedStationName(response.data.data[0].name);
                setId(response.data.data[0].id);

                // ✅ Auto trigger data load with default dates
                const from = format(firstDayOfMonth, "yyyy-MM-dd HH:mm:ss");
                const to = format(now, "yyyy-MM-dd HH:mm:ss");
                setFromDate(from);
                setToDate(to);
                setIsEnabled(true);
                setRefresh((prev) => !prev);
            }
        } catch (error) {
            console.log(error);
        }
    };

    getPumpingStation();
}, []);

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setFromDate,
    setToDate,
    setId,
    id,

    fromDate,
    toDate,
  } = usePagination({
    endpoint: `/pumpingstation/getdailyallrunhours`,
    refreshKey,
    enabled: isEnabled,
  });

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [setPageNumber, totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, [setPageNumber, totalPages]);

  const handleClick = () => {
    if (!validateGenerate()) return;

    if (fromDateTime) {
      const from = format(fromDateTime, "yyyy-MM-dd HH:mm:ss");
      setFromDate(from);
    }

    if (toDateTime) {
      const to = format(toDateTime, "yyyy-MM-dd HH:mm:ss");
      setToDate(to);
    }

    setIsEnabled(true);
    setRefresh((prev) => !prev);
  };

  const fetchAllDataForExport = async () => {
    try {
      const response = await ApiService.axiosApi(`/pumpingstation/getdailyallrunhours`, {
        method: "GET",
        params: {
          FromDate: fromDate,
          ToDate: toDate,
          PageNumber: 0,
          PageSize: 0,
        },
      });
      if (response.success) {
        return response.data.data;
      } else {
        toast.error("Unable to fetch full report");
        return [];
      }
    } catch (error) {
      console.log(error);
      toast.error("API Error");
      return [];
    }
  };
  let updatedData
  if (data) {
    updatedData = data.map((data) => {
      return {
        ...data,
        dateTime: format(new Date(data.dateTime), "dd-MM-yyyy"),
      };
    });
  }

  const validateGenerate = () => {
    if (!selectedStationName) {
      toast.warning("Please select Station");
      return false;
    }

    if (!fromDateTime) {
      toast.warning("Please select From Date");
      return false;
    }

    if (!toDateTime) {
      toast.warning("Please select To Date");
      return false;
    }

    if (new Date(fromDateTime) > new Date(toDateTime)) {
      toast.warning("From Date cannot be greater than To Date");
      return false;
    }

    return true;
  };

  return (
    <>
      <Breadcrumbs mainTitle="Run Hours" parent="Pumping Station Reports" />
      <div
        className="w-100 bg-light-primary px-4  py-2 d-flex justify-content-between align-items-center"
        style={{
          width: "100%",
          height: "100px",
          border: "1px solid rgb(43, 94, 94, 0.1)",
        }}
      >
        <div className=" d-flex align-items-center justify-content-evenly dropdowninput-wrapper">
          <div className="d-flex flex-column custom-dropdown-wrapper">
            <Label>Pumping Station:</Label>

            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggleDropdown}
              style={{
                width:'50%'
              }}
            >
              <DropdownToggle
                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
                style={{
                  fontWeight: 500,
                  borderRadius: "5px",
                  padding: "8px 16px",
                  width: "100%",
                  height: "36px",
                }}
                color="whitesmoke"
              >
                {selectedStationName ? selectedStationName : "Pumping Station"}
              </DropdownToggle>

              <DropdownMenu
                className="custom-dropdown-menu"
                style={{
                  overflowY: "auto",
                  boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  padding: "8px 0",
                }}
              >
                {pumpingStationData.map((data: any) => (
                 <DropdownItem
                 onClick={() => {
                   setSelectedStationName(data.name);
                   setId(data.id); // keep this in sync too
                 }}
                 key={data.id}
               >
                 {data.name}
               </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>

          <div className="report-input-div mx-4 input-border d-flex flex-column report-datetime-input">
            <Label>From Date:</Label>
            <DateTimePicker
              className="report-input"
              dateFormat="dd/MM/yyyy"
              placeholderText="DD-MM-YYYY"
           
              onChange={(date: any) => setFromDateTime(date)}
              selected={fromDateTime}
              isClearable
           
            />
          </div>

          <div className="report-input-div mx-4  input-border  d-flex flex-column report-datetime-input">
            <Label>To Date:</Label>
            <DateTimePicker
              className="report-input"
              dateFormat="dd/MM/yyyy"
              placeholderText="DD-MM-YYYY"
            
              onChange={(date: any) => setToDateTime(date)}
              selected={toDateTime}
              isClearable
             
            />
          </div>
        </div>

        <div className="d-flex justify-content-end gap-5" style={{
             width:'40%'
        }}>
          <div className=" d-flex flex-column " style={{
             width:'20%'
        }}>
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <Button className="px-0 me-2" style={{
                 width:'100%', whiteSpace: 'nowrap',
                 overflow: 'hidden',
                 textOverflow: 'ellipsis' 
            }} color="success" onClick={handleClick}>
              Generate
            </Button>
          </div>

          <div className=" d-flex flex-column" style={{
             width:'20%'
        }}>
            <Label style={{ visibility: "hidden" }}>Generate</Label>
            <ExportExcel
              getData={fetchAllDataForExport}
              fileName={"Pumping_Station_Run_Hours"}
              hiddenColumns={["id"]}
              EffectiveFrom={fromDate}
              toDate={toDate}
            />
          </div>
        </div>
 </div>

      <div className="mt-2 bg-white">
        <Table
          isAction={false}
          data={updatedData}
          columns={[
            { header: "Date", accessor: "dateTime" },
            { header: "Pump 1 Run Hrs", accessor: "pmP1_RUN_HOURS" },
            { header: "Pump 2 Run Hrs", accessor: "pmP2_RUN_HOURS" },
            { header: "Pump 3 Run Hrs", accessor: "pmP3_RUN_HOURS" },
            { header: "Pump 4 Run Hrs", accessor: "pmP4_RUN_HOURS" },
            { header: "Pump 5 Run Hrs", accessor: "pmP5_RUN_HOURS" },
          ]}
          buttons={[]}
        />
        {(!updatedData || updatedData.length === 0) && (
    <div className="d-flex justify-content-center py-3 text-muted">
        No data available
    </div>
)}
        <div
          className=" d-flex justify-content-end align-content-center"
          style={{ marginRight: "10px", marginTop: "10px" }}
        >
          <p style={{ marginRight: "10px", marginTop: "8px" }}>
            Page {pageNumber} of {totalPages}
          </p>
          <button
            onClick={handlePrev}
            disabled={pageNumber === 1}
            className={`icon-button ${
              pageNumber === totalPages ? `icon-button` : ""
            }`}
          >
            <LeftIcon className="icon" />
          </button>
          <button
            className={`icon-button ${
              pageNumber === totalPages ? "disabled" : ""
            }`}
            onClick={handleNext}
            disabled={pageNumber === totalPages}
          >
            <RightIcon className="icon" />
          </button>
        </div>
      </div>
 
    </>
  );
};

export default PumpingStationRunHours;
